const TEAM = [
  {
    image: 'https://hometap.dream.press/wp-content/uploads/abhinaya_headshot.jpg',
    name: 'Abhinaya Nakka',
    title: 'Software Engineer',
    blurb:
      'As a software engineer, Abhinaya is constantly learning new things and turning that knowledge into cool new features for current and prospective Hometap homeowners. She also builds us handy tools when we ask (beg), “Could we have something that does this?” Just make sure to ask her first thing in the morning before she’s hunkered down in afternoon code-mode.',
  },
  {
    image: 'https://hometap.dream.press/wp-content/uploads/Team_Headshot-Lg_AdamJ.jpg',
    name: 'Adam Jaskievic',
    title: 'Senior Regulatory and Product Counsel',
    blurb:
      'When it comes to the financial industry, there are lots of federal and state regulations. That’s where Adam comes in. As Hometap’s regulatory and product counsel, he’s responsible for ensuring all our policies comply with all applicable rules—and that our homeowners are protected. When he’s not translating the law for us, you can find him planning his next vacation.',
  },
  {
    image: 'https://hometap.dream.press/wp-content/uploads/Team_Headshot-Lg_AdamS.jpg',
    name: 'Adam Sigel',
    title: 'Head of Product',
    blurb:
      'Equally motivated by cookies and customer satisfaction, Adam collaborates with our engineers, designers, and marketers to determine and strategize how Hometap’s business priorities should be addressed—and measured. A movie and TV connoisseur (and an admitted Stanley Tucci superfan), Adam spends his evenings and weekends making pizza, hiking, and drumming alongside his dog, Murray.',
  },
  {
    image: 'https://hometap.dream.press/wp-content/uploads/Team_Headshot-Lg_AdrianH.jpg',
    name: 'Adrian Herr',
    title: 'Director of Finance',
    blurb:
      'As Hometap’s Director of Finance, Adrian helps our team use numbers to make informed decisions. Untangling a good complex problem is his sweet spot, and his work helps our investor relations, marketing, and product strategy teams stay in the know. A frequent sailor who loves a good adventure, Adrian’s ideal home would be right on the water.',
  },
  {
    image: 'https://hometap.dream.press/wp-content/uploads/alex_jacob_headshot.jpg',
    name: 'Alex Jacobs',
    title: 'Investment Manager',
    blurb:
      'Alex is motivated by problem solving and financial freedom, much like the Hometap homeowners he helps as an Investment Manager. Beyond offering step-by-step guidance on Hometap Investments, he can also offer valuable tips on all things athletic (street cred: he completed the NYC marathon). Just ask him after he’s exercised—that’s when his brain is at its sharpest.',
  },
  {
    image: 'https://hometap.dream.press/wp-content/uploads/Team_Headshot-Lg_AndreaG.jpg',
    name: 'Andrea Garvey',
    title: 'VP, Human Resources',
    blurb:
      'Considering herself a “partner for people,” Andrea is Hometap’s VP of HR. That means she’s responsible for much of what makes Hometap, Hometap, like finding great people to join our team and creating a culture that makes this one of the best places to work in Boston (and beyond). She makes sure we’re happy and we have everything we need to deliver our best work.',
  },
  {
    image: 'https://hometap.dream.press/wp-content/uploads/Team_Headshot-Lg_AndrewV.jpg',
    name: 'Andrew Vassallo',
    title: 'VP, Capital',
    blurb:
      "Anyone who's balanced a budget knows finances can be…complicated. Andrew has made it his business to know, and that's why we put him in charge of capital operations. A background in investment banking and venture capital helps—so does the fact that he was Co-founder and CEO of start-up Spogo.",
  },
  {
    image: 'https://hometap.dream.press/wp-content/uploads/annmarie.jpg',
    name: 'Ann-Marie Tingley',
    title: 'Recruiter',
    blurb:
      'Ann-Marie scours resumes, checks references, and conducts interviews to find the best-of-the-best people to join Hometap. She looks for the right fit not just for individual teams, but also the company as a whole, making the process kind of like solving two jigsaw puzzles at once. Fortunately, she has more than a decade of experience, making her a recruitment puzzle wizard.',
  },
  {
    image: 'https://hometap.dream.press/wp-content/uploads/Team_Headshot-Lg_AnnieW.jpg',
    name: 'Annie Wieland',
    title: 'Application Specialist',
    blurb:
      'Annie was voted by her grade-school peers as “most bubbly personality,” and we feel like it’s one superlative that still holds true. She still maintains that positive energy in her day-to-day role as Application Specialist. Working behind-the-scenes with our other teams, she gathers all the materials needed to ensure homeowners’ applications are complete and accurate.',
  },
  {
    image: 'https://hometap.dream.press/wp-content/uploads/Team_Headshot-Lg_AshleyH.jpg',
    name: 'Ashley Hawes',
    title: 'Partner Marketing Manager',
    blurb:
      'As our partner marketing manager, Ashley helps us get the word out about Hometap by connecting with personal finance websites, mortgage brokers, financial advisors, realtors, contractors… the list goes on. She makes sure homeowners understand they have options beyond loans when it comes to accessing their home equity. She wakes up super early, loves coffee, and is a list-making dynamo.',
  },
  {
    image: 'https://hometap.dream.press/wp-content/uploads/cat_scott_headshot.jpg',
    name: 'Cat Scott',
    title: 'Product Manager',
    blurb:
      'You could say Cat’s always been good at building things. As the Jacksonville Beach Spelling Bee Runner-Up, she has traded building words for building new and improved product features. For Hometap homeowners, that means a more efficient experience. For Cat, that means lots of noodling to find the best solutions.',
  },
  {
    image: 'https://hometap.dream.press/wp-content/uploads/Catherine Higgins_headshot.jpg',
    name: 'Catherine Higgins',
    title: 'Application Specialist',
    blurb:
      'As a former high school All-American, Catherine knows what it takes to be a successful team player. That’s good news for Hometap homeowners: as an application specialist, she’s the person on your team who makes sure you crossed your t’s and dotted your i’s—and that your application is complete, accurate, and can move forward in the process.',
  },
  {
    image: 'https://hometap.dream.press/wp-content/uploads/Team_Headshot-Lg_CharlieV.jpg',
    name: 'Charlie Vrettos',
    title: 'Principal Software Engineer',
    blurb:
      "Perhaps Charlie was destined for greatness given his innate ability to assemble pretty much anything. Or maybe it's just that he works hard. Either way, we're glad to have him at Hometap, where he, in his own humble words, \"Builds stuff. Digital stuff.\" He's the one building what you see on our platform; making sure you have a flawless, secure, and seamless user experience.",
  },
  {
    image: 'https://hometap.dream.press/wp-content/uploads/Chris Peterson_headshot.jpg',
    name: 'Chris Peterson',
    title: 'Investment Manager',
    blurb:
      'Chris is a former National Geographic Geography Bee Champion, which means we’re willing to bet he knows something about the area you live. While you don’t have to quiz him on that, you can quiz him on the start-to-finish Hometap process. As an Investment Manager, Chris listens closely to homeowners’ need and works with them to make sure those needs are met.',
  },
  {
    image: 'https://hometap.dream.press/wp-content/uploads/connor_daly_headshot.jpg',
    name: 'Connor Daly',
    title: 'Data Scientist / Financial Product Analyst',
    blurb:
      'Connor’s job is to predict the future … or at least guide Hometap toward solving business challenges in the smartest way possible for the company and our homeowners. As a data scientist, he combines elements of statistics and computer science to extract insights and identify trends from what just looks like too many numbers to us.',
  },
  {
    image: 'https://hometap.dream.press/wp-content/uploads/conor_kenrick_headshot.jpg',
    name: 'Conor Kenrick',
    title: 'Investment Manager',
    blurb:
      'Growing up, Conor wanted to help people. When realized he had no ability to stomach blood he knew becoming a doctor wasn’t the right route. But as a Hometap Investment Manager, Conor is helping people in other ways, giving homeowners the guidance needed to understand the investment process from application to offer.',
  },
  {
    image: 'https://hometap.dream.press/wp-content/uploads/Team_Headshot-Lg_DanA.jpg',
    name: 'Dan Amato',
    title: 'Head of Sales',
    blurb:
      'A former wrestling champion, Dan is Hometap’s ultimate team player: He oversees our investment managers, and gets to know homeowners to deliver a great experience, from the first introduction to signing paperwork. Driven, optimistic, and just plain-old nice, Dan’s motivation to help homeowners informs every task he tackles. But when Dan gets home, it’s relaxation all the way.',
  },
  {
    image: 'https://hometap.dream.press/wp-content/uploads/Team_Headshot-Lg_DanB.jpg',
    name: 'Dan Burnett',
    title: 'Director of Capital Operations',
    blurb:
      'Despite being named the “Most Proficient at Boxing Out for a Rebound” as part of his 8th grade basketball team, Dan’s NBA career didn’t quite take off like his career in operations. As Director of Capital Operations, Dan helps us make investments in as many homes as possible. He also keeps tabs on all of those investments.',
  },
  {
    image: 'https://hometap.dream.press/wp-content/uploads/devlin_keogh_headshot_2.jpg',
    name: 'Devlin Keogh',
    title: 'Investment Manager',
    blurb:
      'Having worked as a realtor, Devlin is no stranger to working with homeowners. Now, as a Hometap Investment Manager, instead of helping homeowners buy and sell homes, he’s helping homeowners access their home equity. (Or, as he describes it, viewing the house as a piggy bank from which homeowners can borrow to fund their other goals.)',
  },
  {
    image: 'https://hometap.dream.press/wp-content/uploads/Team_Headshot-Lg_georgev2.jpg',
    name: 'George Marangoly',
    title: 'Senior Investment Manager',
    blurb:
      'George is proof you’re never limited by your undergraduate focus. Majoring in biology, he then became a real estate broker. Now, as a Hometap Investment Manager, George is helping homeowners tap into their home equity so they can fulfill their financial goals. When he’s not at work, you can probably find him… still working or maybe prepping for his fourth Boston Marathon.',
  },
  {
    image: 'https://hometap.dream.press/wp-content/uploads/Team_Headshot-Lg_GregS.jpg',
    name: 'Greg Schultz',
    title: 'Senior Data Scientist',
    blurb:
      'Taking an analytical, meticulous, and open-minded approach to work makes for a great data scientist—and that’s Greg to a T. Whether analyzing Hometap’s data sets for key insights and trends or building predictive models, he loves nothing more than getting creative to solve a deeply technical problem—the more nuanced, the better.',
  },
  {
    image: 'https://hometap.dream.press/wp-content/uploads/Team_Headshot-Lg_JeffG.jpg',
    name: 'Jeff Glass',
    title: 'CEO',
    blurb:
      "Jeffrey is our CEO and a well-qualified one at that. Having successfully built five (!) companies in his career—not to mention an impressive record as Managing Director at Bain Capital—there's no one we'd rather have at the head of Hometap than him. He's a natural entrepreneur, and nothing thrills him more than creating something that didn't exist before.",
  },
  {
    image: 'https://hometap.dream.press/wp-content/uploads/Team_Headshot-Lg_JeffH.jpg',
    name: 'Jeff Horne',
    title: 'Investment Analyst',
    blurb:
      'Jeff, an Investment Analyst, majored in economics. But he also minored in art history and computer science. With this multi-disciplined background, he crunches numbers and scrutinizes data to see if homeowners and Hometap are a good fit. He’s the first step in the Hometap Investment process, working closely with our investment team to make sure any offers make everyone better off.',
  },
  {
    image: 'https://hometap.dream.press/wp-content/uploads/Team_Headshot-Lg_JonnyF.jpg',
    name: 'Jonny Friedman',
    title: 'Investment Manager',
    blurb:
      'Jonny can dunk, but lucky for us (and you), he opted to pursue business (although basketball remains a hobby). As an Investment Manager, Jonny talks to homeowners to see if a Hometap Investment makes sense for their financial situation. Fortunately he’s an early riser, so he’s helping homeowners discover how they can solve their financial goals bright and early.',
  },
  {
    image: 'https://hometap.dream.press/wp-content/uploads/julie.jpg',
    name: 'Julie Menzin',
    title: 'Front-end Engineer',
    blurb:
      'A one-time award winner of “Best Trapeze Balance” during a work outing, Julie opted to stick with writing code instead of running off with the circus. As our senior front end engineer, she builds the interface and interactions across the Hometap website. So, when you click a button on our website, you can thank Julie that it takes you to the intended destination.',
  },
  {
    image: 'https://hometap.dream.press/wp-content/uploads/Team_Headshot-Lg_JulioC.jpg',
    name: 'Julio Carrera',
    title: 'Senior Software Engineer',
    blurb:
      'Julio earned his MS in Computer Science at Carnegie Mellon. Today, his role as a senior full-stack engineer allows him to write code for both the back end (the processes that make up and power the site) and the front end (what users see and interact with). An enthusiastic curler, Julio holds bragging rights as a curling finalist at the Broomstones Oktoberfest Open Curling Spiel.',
  },
  {
    image: 'https://hometap.dream.press/wp-content/uploads/Team-Headshots_Lg_KaseyL (1).jpg',
    name: 'Kasey Looney',
    title: 'Investment Operations Manager',
    blurb:
      "Once upon a time, Kasey wanted to be a firefighter, cruising in the big red truck and owning all the Dalmatians. Her role as Investment Operations Manager didn’t come with puppies, but she's a pro at putting out fires. Kasey works tirelessly to ensure your application is in tip-top shape before our underwriting team reviews it.  She’s also the one who ensures your investment is funded.                            ",
  },
  {
    image: 'https://hometap.dream.press/wp-content/uploads/Kylee.jpg',
    name: 'Kylee Galer',
    title: 'Office Manager',
    blurb:
      'If you think offices just “run themselves,” you haven’t met Kylee. From restocking supplies, including much-needed snacks, to placing orders and assisting teams with administrative duties, she enforces order in the Hometap office. It’s kind of like her childhood dream of being a police officer, only with slightly less action.',
  },
  {
    image: 'https://hometap.dream.press/wp-content/uploads/Team_Headshot-Lg_LindseyC.jpg',
    name: 'Lindsey Connors',
    title: 'Customer Experience Designer',
    blurb:
      'Lindsey once won the Boston University Ad Lab Award for “Seeing The Big Picture &amp; The Smaller Ones Too.” It’s that dual thinking that allows her, as Hometap’s customer experience designer, to bring new, engaging ideas to life on the web and in print. Lindsey’s unconventional approach to creativity and get-stuff-done attitude certainly helps her get the job done.',
  },
  {
    image: 'https://hometap.dream.press/wp-content/uploads/Team_Headshot-Lg_LoraineB.jpg',
    name: 'Loraine Burger',
    title: 'Content Marketing Manager',
    blurb:
      "As Hometap’s Content Marketing Manager, Loraine makes sure homeowners know about Hometap and have the resources they need to make the best decision possible, and that homeowners' inspiring stories are shared with those considering an investment.",
  },
  {
    image: 'https://hometap.dream.press/wp-content/uploads/Team_Headshot-Lg_MarthaC.jpg',
    name: 'Martha Carl',
    title: 'Head of Design',
    blurb:
      'Martha’s artistic talent was spotted young: she was named 1992’s "Best Artist" in her preschool. Then came the Internet and Martha swapped the crayons for a stylus. She’s the brains behind our website design, making sure it’s easy to use and looks good, too.',
  },
  {
    image: 'https://hometap.dream.press/wp-content/uploads/mattc.jpg',
    name: 'Matt Campo',
    title: 'Senior Accountant',
    blurb:
      'Matt sees accounting as similar to solving a large puzzle. We’re not sure what puzzle includes the stress of audits, but we’ll take his word. In addition to financial modeling and maintaining “the books,” Matt is a pro bartender. If we had to guess, his signature cocktail is the “Month-End Manhattan”—the perfect drink for getting through even the hairiest monthly signing.',
  },
  {
    image: 'https://hometap.dream.press/wp-content/uploads/Team_Headshot-Lg_MaxC.jpg',
    name: 'Maxwell Campion',
    title: 'Senior Investment Manager',
    blurb:
      'As an Investment Manager and one of the original thinkers behind the Hometap concept, Max understands why a product like Hometap is so needed today, and works with homeowners to determine how we can work together. He likes to think he\'s known for being a scratch golfer, but he\'s perhaps more famous for the fact that he watched every episode of "Seinfeld" before the age of 10.',
  },
  {
    image: 'https://hometap.dream.press/wp-content/uploads/molly.jpg',
    name: 'Molly Smith',
    title: 'Application Specialist',
    blurb:
      'As Application Specialist, Molly helps homeowners put together and complete their applications, ensuring our other teams have everything needed to put together an investment estimate as quickly and accurately as possible. Her attention to detail ensures the process is smooth sailing for homeowners. When she’s not at work you can find her actually sailing in Boston Harbor.',
  },
  {
    image: 'https://hometap.dream.press/wp-content/uploads/nicki_duggan_headshot.jpg',
    name: 'Nicki Duggan',
    title: 'Program Manager, Planning',
    blurb:
      'Nicki has all the coordination you’d expect from a high school Ballroom Dancing Champion, which is exactly what you want in a program manager. She works across teams to keep every step of each project on track. Some may call it herding cats. We call it being able to see the big picture and expertly organizing everything to get it done.',
  },
  {
    image: 'https://hometap.dream.press/wp-content/uploads/Team_Headshot-Lg_Nishanth.jpg',
    name: 'Nishanth Manjunatha',
    title: 'Software Engineer',
    blurb:
      "Nishanth started at Hometap as an intern with our Software Engineering team while he pursued his Master's Degree at Northeastern University. We’re not sure how he balanced college life with a schedule packed with coding and de-bugging to maintain a flawless website and user experience, but he did it without breaking a sweat, so we decided to keep him. Fortunately, he was happy to stay.",
  },
  {
    image: 'https://hometap.dream.press/wp-content/uploads/Team_Headshot-Lg_NoahS.jpg',
    name: 'Noah Spaulding',
    title: 'Chief Legal Officer',
    blurb:
      'A one-time aspiring herpetologist, Noah traded his pet snakes for three cats and a law degree. He works across teams to keep us all far, far away from legal hot water. When he’s not making sure deals are properly negotiated, Noah is hanging out on his porch with a book and a beer.',
  },
  {
    image: 'https://hometap.dream.press/wp-content/uploads/Team_Headshot-Lg_OlinN.jpg',
    name: 'Olin Nelson',
    title: 'Sales & Marketing Operations Manager',
    blurb:
      'Combine Olin’s prior experience building a business from the ground up with his time as an analyst and you have a winning combination for uncovering data-backed opportunities to improve Hometap for our homeowners. As our sales and marketing ops manager, Olin is our new idea generator and one of the last to leave the office. It makes sense when you learn about his daily caffeine intake.',
  },
  {
    image: 'https://hometap.dream.press/wp-content/uploads/Team_Headshot-Lg_OwenM.jpg',
    name: 'Owen Myers',
    title: 'Lead Data Engineer',
    blurb:
      'Builder, problem-solver—that’s Owen, Hometap’s lead data engineer. You’ll find him tackling Hometap’s data structures and pipelines to help better understand our customers, and then using that data to build and improve our products and services. Owen was a postdoc at the University of North Carolina Charlotte and then a data engineer at a startup before joining Hometap.',
  },
  {
    image: 'https://hometap.dream.press/wp-content/uploads/rachelc.jpg',
    name: 'Rachel Cholewinski',
    title: 'Marketing Coordinator',
    blurb:
      'A hummus connoisseur (really, she’s a former brand ambassador for a hummus company), Rachel can argue the merits of both original and roasted red pepper. She’s also responsible for all things marketing: market research, branding, industry trends, promotional opportunities, you name it. How does she stay on top of it all? Compulsive list-making and coffee. Lots of coffee.',
  },
  {
    image: 'https://hometap.dream.press/wp-content/uploads/Team_Headshot-Lg_RachelK.jpg',
    name: 'Rachel Keohan',
    title: 'Head of Marketing',
    blurb:
      'When she’s not winning chili cook-offs in her envy-worthy kitchen, Rachel leads the charge to elevate Hometap’s brand awareness with resonant, multi-channel marketing campaigns. No revenue mountain is too steep to climb, nor sales target too ambitious to meet for this former internal auditor (she even makes that sound exciting).',
  },
  {
    image: 'https://hometap.dream.press/wp-content/uploads/sam.jpg',
    name: 'Samantha Sandler',
    title: 'Investment Manager',
    blurb:
      'Samantha’s day begins when Ollie, her golden retriever and reliable alarm clock, wakes her up for a game of catch in the park. (That practice may have helped her become a two-time recipient of the “Golden Glove” award at her family’s annual softball game.) Once she’s in the office, Samantha gets to work helping homeowners through the entire Hometap process.',
  },
  {
    image: 'https://hometap.dream.press/wp-content/uploads/Team_Headshot-Lg_SarahD.jpg',
    name: 'Sarah Dekin',
    title: 'COO',
    blurb:
      'Serving as CMO at major brands such as Zipcar, House of Blues, and Virgin, Sarah brings a powerful sales and marketing strategy to her role at Hometap. With a fearlessness that must have come in handy during her time as a white-water kayak instructor, she works hard to get the word out about Hometap and to connect us with people who want to take advantage of the equity in their homes.',
  },
  {
    image: 'https://hometap.dream.press/wp-content/uploads/Team_Headshot-Lg_Steve.jpg',
    name: 'Steve Leibman',
    title: 'VP of Engineering',
    blurb:
      'Technology has come a long way since Steve first figured out how to type in BASIC programs on the TRS-80 (don’t worry, we had to Google that, too). So, it’s a good thing he likes to learn. As VP of Engineering, Steve, and his team often find themselves doing things they didn’t know how to do the week before, using new tools, and building something they never thought they could build.',
  },
  {
    image: 'https://hometap.dream.press/wp-content/uploads/Team_Headshot-Lg_TomC.jpg',
    name: 'Tom Corra',
    title: 'CFO',
    blurb:
      'As Hometap’s Chief Financial Officer, Tom oversees our investment strategy, data science team, financial operations, and underwriting. In addition to improving Hometap in the short-term, he’s focused on the long-term, and has his sights set on what Hometap will be five years from now.',
  },
  {
    image: 'https://hometap.dream.press/wp-content/uploads/TomK.jpg',
    name: 'Tom Kazakov',
    title: 'Software Engineer',
    blurb:
      'Tom has more than 15 years in software across a variety of roles, meaning he’s fluent in the language of computer. As a Hometap software engineer, he’s currently focused on building things: web systems, apps, you name it. When he’s not tinkering with tech, he’s playing D&amp;D, hanging with his kids, or avoiding the “what restaurant should we eat at?” question (sometimes all three at once).',
  },
  {
    image: 'https://hometap.dream.press/wp-content/uploads/Team_Headshot-Lg_WhitneyT.jpg',
    name: 'Whitney Trook',
    title: 'Product Manager',
    blurb:
      'As product manager, Whitney researches ways to make Hometap better, for our homeowners, investors, and our team—and then identifies all the moving pieces needed to make it happen. The result? A seamless investment process for you, and ample snack supply for us.',
  },
  {
    image: 'https://hometap.dream.press/wp-content/uploads/Team_Headshot-Lg_ZachM.jpg',
    name: 'Zach Mason',
    title: 'Senior Investment Manager',
    blurb:
      'When Zach arrives at work, he’s generally already hit the gym and had his coffee so he’s fired up and ready to help you determine if a Hometap Investment makes sense for you. After work, you’ll find him on the soccer field, softball diamond, or any other athletic playing surface, competing for company teams or rec leagues. Yeah, we wish we had his energy, too.',
  },
];

export default TEAM;
